module.exports = __webpack_public_path__ + "static/media/icon_documents.34b52189.svg";